import { __module as e } from "../../../_virtual/isHash.js";
import { a as t } from "./util/assertString.js";
Object.defineProperty(r = e.exports, "__esModule", {
  value: !0
}), r.default = function (e, t) {
  return (0, s.default)(e), new RegExp("^[a-fA-F0-9]{".concat(a[t], "}$")).test(e);
}, s = t && t.__esModule ? t : {
  default: t
}, a = {
  md5: 32,
  md4: 32,
  sha1: 40,
  sha256: 64,
  sha384: 96,
  sha512: 128,
  ripemd128: 32,
  ripemd160: 40,
  tiger128: 32,
  tiger160: 40,
  tiger192: 48,
  crc32: 8,
  crc32b: 8
}, e.exports = r.default, e.exports.default = r.default;
var r,
  s,
  a,
  o = e.exports;
export { o as i };